import { Injectable, inject } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { IBareOptionsMap } from '../product-configuration-configurable';

@Injectable()
export class ProductConfigurationConfigurableOptionsService {
    /**
     * Dependencies
     */
    private attributeResource = inject(AttributeResource);

    /**
     * Buffer for generated options maps
     */
    private optionsMapBuffer = new Map<Product, IBareOptionsMap>();

    /**
     * Generates options map for given configurable
     * Includes all options, sorted
     */
    getOptionsMap(product: Product<IProductDataV3>): IBareOptionsMap {
        if (!this.optionsMapBuffer.has(product)) {
            if (!product.data || !product.hasV3) {
                throw new Error('Product data is not provided');
            }
            if (!product.isConfigurable) {
                throw new Error('Product is not configurable');
            }

            const options = product.data.options!.configurable!;
            const attributeCodes = this.sortAttributes(Object.keys(options));
            const optionsMap: IBareOptionsMap = attributeCodes.map(attributeCode => {
                const attributeEntry = options[attributeCode];
                const values = this.sortValues(
                    attributeCode,
                    Object.keys(attributeEntry)
                        .filter(i => i.length)
                        .map(i => Number(i))
                );

                return {
                    attribute: this.attributeResource.getExisting(attributeCode)!,
                    values
                };
            });

            this.optionsMapBuffer.set(product, optionsMap);
        }

        return this.optionsMapBuffer.get(product)!;
    }

    private sortAttributes(configurableAttributes: string[]) {
        return configurableAttributes;
    }

    private sortValues(attributeCode: string, values: number[]) {
        const options = this.attributeResource.getExisting(attributeCode)?.data!.options;
        if (options) {
            return options.filter(i => values.includes(i.value)).map(i => i.value);
        }
        return values;
    }
}
